import * as React from 'react';
import { useEffect, useLayoutEffect, useRef, useState } from "react";
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useSelector } from 'react-redux';
import {flushSync} from 'react-dom'
import {
  Divider,
  IconButton,
  Select,
  Typography,
  FormControl,
  InputLabel,
  FormControlLabel,
  FormLabel,
  MenuItem,
  Radio,
  RadioGroup,
  FormHelperText,
  Box,
  Stack,
  Paper,
  Checkbox,
  Icon
} from '@mui/material';
import { fullCopy, isValidDate, printVariable, download, uuidv4 } from '@util/helper';
import WebService from '@util/webService';
import useSnackbar from '@hooks/useSnackbar';
import useIndicator from '@hooks/useIndicator';
import axios from 'axios';
import { Fragment } from 'react';
import moment from 'moment';
import { Grid } from "@mui/material/";
import useDelegate from "@hooks/useDelegate";
import { styled } from "@mui/material/styles";
import ConfirmDialog from "@components/ConfirmDialog";

import CircularProgress from "@mui/material/CircularProgress";
import loading from '@images/loading.gif'

// date
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import 'dayjs/locale/ko';
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import AttachFileOutlinedIcon from '@mui/icons-material/AttachFileOutlined';
import CloseIcon from '@mui/icons-material/Close';
import { attempt, keyBy } from 'lodash';
import useAlert from "@hooks/useAlert";
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import FlatButton from '@components/FlatButton';
import {
  DndContext,
  closestCenter,
  KeyboardSensor,
  PointerSensor,
  useSensors,
  MeasuringStrategy
} from '@dnd-kit/core';
import {
  arrayMove,
  SortableContext,
  useSortable,
  sortableKeyboardCoordinates,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable';

import { CSS } from '@dnd-kit/utilities';
import { json } from 'react-router-dom';
import { fireEvent } from '@testing-library/react';
import { AlarmAdd, Preview } from '@mui/icons-material';
import ClearOutlinedIcon from '@mui/icons-material/ClearOutlined';
import { getNow, } from '@util/helper';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';

const generatePlans = (voucherId, smstId, startStr, endStr) => {
  const start = new Date(startStr)
  const end = new Date(endStr)
  const plans = []
  let chasu = 1
  const now = getNow()
  let currentStart = new Date(start);

  while (currentStart <= end) {
    // 해당 월의 마지막 날 계산 (다음 달의 0번째 날 = 이번 달의 마지막 날)
    let currentEnd = new Date(currentStart.getFullYear(), currentStart.getMonth() + 1, 0, 23, 59, 59);

    // 만약 계산된 월말이 전체 종료일(end)보다 늦다면, 전체 종료일로 맞춤
    if (currentEnd > end) {
      currentEnd = new Date(end);
    }

    plans.push({
      id: -1,
      voucherId: voucherId,
      smstId: smstId,
      chasu: chasu++,
      startTime: formatDate(currentStart),
      endTime: formatDate(currentEnd),
      activeYn: 'N',
      closeYn: 'N',
      uptTime: now,
      regTime: now,
      key1: uuidv4(),
      key2: uuidv4(),
    });

    // 다음 차수 시작일 설정 (현재 종료일 + 1초)
    currentStart = new Date(currentEnd.getTime() + 1000)
  }

  return plans
}

// YYYY-MM-DD HH:mm:ss 포맷팅 함수
const formatDate = (date) => {
  const pad = (n) => n.toString().padStart(2, '0');
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ` +
    `${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
}

const ManagerVoucherPartMod = ({ record, dialogHandler, callback }) => {
  const [openSnackbar] = useSnackbar()
  const [openIndicator, closeIndicator, renderIndicator] = useIndicator()
  // const [activeRow, set_activeRow] = useState({...record})
  // redux
  const codes = useSelector(state => state.codeReducer);
  const account = useSelector(state => state.accountReducer);
  const schola = useSelector(state => state.scholaReducer);

  const [allSmsts, set_allSmsts] = useState([])
  const originSmstsRef = useRef(allSmsts)
  const dateFormat = 'YYYY-MM-DD HH:mm:ss';
  const dateFormat2 = 'YYYY-MM-DD 23:59:59';
  const { alert, renderAlert } = useAlert()
  const inputRefs = React.useRef({})
  const [counter, set_counter] = useState(100000)
  const updateRef = useRef(false)
  const [editArea, set_editArea] = useState({
    base: false,
    plan: false,
  })
  const [onlyAlive, set_onlyAlive] = useState(true)
  const [autoChasu, set_autoChasu] = useState(true)

  const originRef = useRef(JSON.parse(JSON.stringify(record)))
  const [alarm, set_alarm] = useState({
    msg: '',
    elKey: ''
  })
  const btnRef1 = useRef()
  const scrollPos = useRef(0)
  const scrollContainerRef = useRef(null)
  const [dirtyFields, set_dirtyFields] = useState({})

  const fixError = (key) => {
    const prevError = dirtyFields[key]
    if (prevError) {
      set_dirtyFields({ ...dirtyFields, [key]: '' })
    }
  }

  const setInputRef = (el, key) => {
    if (el) inputRefs.current[key] = el;
    else delete inputRefs.current[key]; // unmount 시 정리
  }

  const handleClose = async (event, reason) => {
    if (reason && reason === "backdropClick") {
      return
    }
    else {
      dialogHandler[1](false)
      if (callback) {
        callback()
      }
    }
  }

  const canEdit = (area) => {
    if (activeRow.id === -1) {
      return true
    }
    else {
      if (editArea) {
        return editArea[area]
      }
      return false
    }
  }


  const handleFormChange = (e) => {
  }




  const onLoad = async () => {
    await fetchSmsts()
  }

  const validate = async (name, value) => {
    let err = ''
    if (name === 'name') {
      if (!value.trim()) {
        err = '바우처명이 비어 있습니다.'
      }
    }
    else if (name === 'year') {
      if (!moment(value, "YYYY", true).isValid()) {
        err = '년도를 4자리로 입력해 주세요'
      }
    }
    else if (name === 'budget') {
      const amountRegex = /^(0|[1-9][0-9]*)$/
      const num = Number(value)
      if (amountRegex.test(value) && !isNaN(num) && Number.isInteger(num) && num >= 0) {
        // ok - 정상적인 정수 금액
      }
      else {
        err = '예산 금액을 숫자로 입력해 주세요.'
      }
    }
    else if (name === 'catCode') {
      if (!value.trim()) {
        err = '바우처 구분을 선택해 주세요.'
      }
    }
    else if (name === 'startTime1') {
      if (!moment(value, 'YYYY-MM-DD HH:mm:ss', true).isValid()) {
        err = `바우처 시작일이 형식에 맞지 않습니다.`
      }
    }
    else if (name === 'endTime1') {
      if (!moment(value, 'YYYY-MM-DD HH:mm:ss', true).isValid()) {
        err = `바우처 종료일이 형식에 맞지 않습니다.`
      }
    }

    else if (name.startsWith('chasu-smst')) {
      if (typeof value === 'function') {
        err = value()
      }
      else {
        const regex = /^[1-4]$/
        if (!regex.test(value)) {
          err = '1 ~ 4 사이의 숫자를 입력해 주세요.'
        }
      }

    }
    else if (name === 'error') {
      if (moment(activeRow.startTime1, dateFormat, true).isAfter(moment(activeRow.endTime1, dateFormat, true))) {
        err = '바우처 시작일은 종료일 이후일 수 없습니다.'
      }
    }

    return err

  }

  const validate2 = (plans, plan, name, value) => {
    if (!moment(value, 'YYYY-MM-DD HH:mm:ss', true).isValid()) {
      return
    }
    const sortedPlans = [...plans].sort((a, b) => a.chasu - b.chasu)
    const prevPlan = sortedPlans.filter(p => p.chasu < plan.chasu).at(-1)
    const nextPlan = sortedPlans.filter(p => p.chasu > plan.chasu).at(0)
    let err = ''
    if (name === 'startTime') {
      if (prevPlan) {
        if (moment(prevPlan.endTime, 'YYYY-MM-DD HH:mm:ss', true).isValid()) {
          if (value.isBefore(prevPlan.endTime)) {
            err = '앞 차수 종료일보다 전일 수 없습니다.'
            console.log(err)
          }
        }
      }
      if(plan.endTime) {
        if (moment(plan.endTime, 'YYYY-MM-DD HH:mm:ss', true).isValid()) {
          if (value.isAfter(plan.endTime)) {
            err = '같은 차수 종료일보다 후일 수 없습니다.'
          }
        }
      }

    }
    else if (name === 'endTime') {
      if (nextPlan) {
        if (moment(nextPlan.startTime, 'YYYY-MM-DD HH:mm:ss', true).isValid()) {
          if (value.isAfter(nextPlan.startTime)) {
            err = '뒷 차수 시작일 보다 후일 수 없습니다.'
          }
        }
      }
      if(plan.startTime) {
        if (moment(plan.startTime, 'YYYY-MM-DD HH:mm:ss', true).isValid()) {
          if (value.isBefore(plan.startTime)) {
            err = '같은 차수 시작일보다 전일 수 없습니다.'
          }
        }
      }
    }

    if(name === 'startTime' || name === 'endTime') {
      const key = name === 'startTime' ? plan.key1 : plan.key2
      set_dirtyFields({...dirtyFields, [key] : err})
    }

  }

  const fetchSmsts = async () => {
    const url = `/smst/last/50/${schola.id}`
    openIndicator()
    const resp = await WebService.get(url)
    closeIndicator()
    if (resp.repCode !== 'ack') {
      alert(resp.repMessage)
      return
    }
    const repMessage = JSON.parse(resp.repMessage)
    const records = JSON.parse(repMessage.records)

    records.forEach(smst => {
      const plans = []
      smst.plans = plans
      activeRow.plans.forEach((plan) => {
        if (plan.smstId === smst.id) {
          plans.push({ ...plan, key1: uuidv4(), key2: uuidv4() })
        }

      })
      smst.checked = smst.plans.length > 0
      // const found = activeRow.plans.find(r2 => r2.sstId === r.id)
      // if (found) {
      //   r.checked = true
      //   r.chasu = found.chasu
      // }
      console.log(`smst:${smst.id} plans=>`, smst.plans)
    })


    originSmstsRef.current = JSON.parse(JSON.stringify(records))
    console.log('oooooo=>', originSmstsRef.current)
    set_allSmsts(records)
  }

  const fetchDelPlans = async () => {
    const url = `/voucher/del/plans/${schola.id}`
    const data = {
      voucher: { ...factor }
    }
    openIndicator()
    const resp = await WebService.post(url, data)
    closeIndicator()
    if (resp.repCode !== 'ack') {
      alert(resp.repMessage)
      return
    }
    const repMessage = JSON.parse(resp.repMessage)
    const delPlans = JSON.parse(repMessage.delPlans)
    return delPlans
  }


  const handleFinalSave = async (area) => {
    const ret = await onSaveArea(area)
    if (ret) {
      set_editArea({ ...editArea, [area]: false })
      set_counter(counter + 1)
    }
  }


  const onClickSave = async (area) => {
    

    if (area === 'plan') {
      const plans = []
      const df = {...dirtyFields}

      for(const smst of allSmsts) {
        for(const plan of smst.plans) {
          const err = '날짜 형식이 맞지 않습니다.'
          if(!plan.startTime || !plan.endTime) {
            
            if(!plan.startTime) {
              df[plan.key1] = err
            }
            if(!plan.endTime) {
              df[plan.key2] = err
            }
          }
          
          plans.push(plan)
        }
      }

      flushSync(() => {
        set_dirtyFields(df)
      })
      
      if(Object.values(df).filter(r => r !== '').length > 0) {
        alert('화면의 에러를 확인해 주세요.')
        return 
      }

      factor.plans = plans
      const delPlans = await fetchDelPlans()
      if (delPlans) {
        console.log('delPlans =>', delPlans)
        if (delPlans.length > 0) {
          btnRef1.current.click()
          return
        }
      }
    }
    console.log('factor12=>', factor)

    await handleFinalSave(area)
  }

  const onSaveArea = async (area) => {
    if (Object.keys(errors).length > 0) {
      alert('데이터에 에러가 있습니다. 화면의 에러를 확인해 주세요.')
      return false
    }

    const url = `/voucher/update/area/${area}/${schola.id}`

    const data = {
      voucher: { ...factor }
    }

    console.log('data=>', data)
    console.log('factor=>', factor)
    if (area === 'base') {
      //
    }
    else if (area === 'plan') {
      //
    }
    else {
      alert('알 수 없는 편집 영역입니다.')
      return false
    }


    openIndicator()
    const resp = await WebService.post(url, data)
    closeIndicator()

    if (resp.repCode !== 'ack') {
      alert(resp.repMessage)
      return false
    }

    openSnackbar('저장되었습니다.')

    const repMessage = JSON.parse(resp.repMessage)
    const newRecord = JSON.parse(repMessage.record)

    originRef.current = JSON.parse(JSON.stringify(newRecord))
    originSmstsRef.current = JSON.parse(JSON.stringify(allSmsts))
    updateState(newRecord)
    updateRef.current = true

    return true
  }

  const onSubmit = async () => {

    const row = { ...activeRow }
    const startTime = moment(row.startTime1, dateFormat).format('YYYY-MM-DD') + ' ' + moment(row.startTime2, "HH:mm:ss").format('HH:mm:00')
    const endTime = moment(row.endTime1, dateFormat).format('YYYY-MM-DD') + ' ' + moment(row.endTime2, "HH:mm:ss").format('HH:mm:00')
    row.startTime = startTime
    row.endTime = endTime



    const url = `/voucher/school/${schola.id}`
    const data = {
      voucher: row,
    }

    openIndicator()
    const resp = await WebService.post(url, data)
    closeIndicator()

    if (resp.repCode !== 'ack') {
      alert(resp.repMessage)
      return
    }

    const repMessage = JSON.parse(resp.repMessage)
    const record = JSON.parse(repMessage.record)
    console.log('record=>', record)
    originRef.current = JSON.parse(JSON.stringify(record))
    updateState(record)
    await handleChange({ target: { name: 'id', value: record.id } })
    openSnackbar('저장되었습니다.')

  }


  const { activeRow, errors, updateState, handleChange, handleSubmit, factor } = useDelegate({
    initialValues: { ...record },
    onSubmit: onSubmit,
    validate: validate,
  });

  console.log('activeRow=>', activeRow)

  const getImgUrls = (delta) => {
    return delta.ops.filter(i => i.insert && i.insert.image).map(i => i.insert.image)
  }


  const catCodeList = codes.filter(r => r.codeGroupId === 'SA32')

  const FormHelperTexts = styled(FormHelperText)`
    width: 100%;
    padding-left: 16px;
    font-weight: 700 !important;
    color: #d32f2f !important;
  `;


  useEffect(() => {
    onLoad()
  }, [])

  // useEffect(() => {
  //   const plans  = allSmsts.plans
  //   if(plans && plans.length > 0) {
  //     console.log('plans=>', plans)
  //     const df = {...dirtyFields}
  //     plans.forEach(plan => {
  //       if(!plan.startTime) {
  //         df[plan.key1] = '날짜 형식이 맞지 않습니다.'
  //       }
  //       if(!plan.startTime) {
  //         df[plan.key2] = '날짜 형식이 맞지 않습니다.'
  //       }
  //     })
  //     set_dirtyFields(dirtyFields)
  //   }
  // }, [allSmsts])


  const EditButtons = ({ area }) => {
    if (activeRow.id === -1) {
      return null
    }

    return (
      <Grid item xs={12}>
        <Stack sx={{ mt: 2 }} direction="row" spacing={2}>
          <Button disabled={editArea[area]} variant="outlined" onClick={() => {
            set_editArea({ ...editArea, [area]: true })

          }} >
            편집
          </Button>
          <Button disabled={!editArea[area]} variant="outlined" sx={{ ml: 2 }} onClick={async () => {
            updateState(originRef.current)
            console.log('originSmstsRef=>', originSmstsRef.current)
            set_allSmsts(JSON.parse(JSON.stringify(originSmstsRef.current)))
            const err = await handleChange()
            set_editArea({ ...editArea, [area]: false })
            set_dirtyFields({})
            set_counter(counter + 1)
            
          }}>
            취소
          </Button>
          <Button disabled={!editArea[area]} variant="contained" sx={{ ml: 2 }}
            onClick={() => {
              console.log('factor=11', factor)
              onClickSave(area)
            }}
          >
            저장
          </Button>
          <ConfirmDialog
            btn={
              <FlatButton ref={btnRef1} style={{ display: 'none' }} />
            }
            title={'주의'}
            content={'연결이 끊기는 차수가 있습니다. 그래도 변경하시겠습니까?'}
            bc={'error'}
            preHandle={async () => {
              return true
            }}
            perform={async () => {
              await handleFinalSave('plan')
            }}
          />
        </Stack>

        <Divider sx={{ mt: 5 }} />
      </Grid>
    )
  }

  return (
    <Box component="form" >
      {renderIndicator()}
      {renderAlert()}
      {/* <Box component="form" > */}
      <Dialog open={dialogHandler[0]} onClose={handleClose} maxWidth='lg' fullWidth PaperProps={{
        sx: { p: 3 }
      }}>
        <DialogTitle>
          <Typography variant='h5' align='center'>
            바우처
          </Typography>
          <Divider/>
        </DialogTitle>
        {/* <DialogContent style={{minHeight:600, backgroundColor: '#e8eaf6'}} > */}
        <DialogContent style={{ minHeight: 300, }} ref={scrollContainerRef} >

          <br />
          <Grid container spacing={1} key={counter}>
            <Grid item xs={12}>
              <Typography variant='h6'>바우처 정보</Typography>
            </Grid>
            <Grid item xs={12} style={{ backgroundColor: '#fff' }}>
              <TextField
                label={'바우처명'}
                fullWidth
                required
                disabled={!canEdit('base')}
                inputRef={(el) => setInputRef(el, 'title')}
                name={'name'}
                defaultValue={activeRow['name']}
                onChange={e => {
                  handleChange(e)
                }}
                onBlur={handleFormChange}
              />
              <FormHelperTexts>{errors?.name}</FormHelperTexts>
            </Grid>
            <Grid item xs={12}>
              <Grid container spacing={1}>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    disabled={!canEdit('base')}
                    label='년도'
                    name='year'
                    defaultValue={activeRow.year}
                    onChange={(e) => {
                      handleChange(e)
                    }}
                  />
                  <FormHelperTexts>{errors["year"]}</FormHelperTexts>
                </Grid>
                <Grid item xs={6}>
                  <FormControl fullWidth>
                    <InputLabel id='catCode'>
                      분류
                    </InputLabel>
                    <Select
                      labelId='catCode'
                      required
                      label='구분'
                      disabled={!canEdit('base')}
                      name={"catCode"}
                      defaultValue={activeRow["catCode"]}
                      onChange={async (e) => {
                        handleChange(e)
                        updateState()
                      }}>
                      {catCodeList.map((l, index) => {
                        return (
                          <MenuItem key={`catCode-${l.id}`} value={l.code}>
                            {l.name}
                          </MenuItem>
                        )
                      })}
                    </Select>
                  </FormControl>
                  <FormHelperTexts>{errors["catCode"]}</FormHelperTexts>
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12}>
              <TextField
                fullWidth
                required
                label={'학생별 바우처 금액'}
                disabled={!canEdit('base')}
                name={'budget'}
                defaultValue={activeRow['budget']}
                onChange={e => {
                  handleChange(e)
                }}
              />
              <FormHelperTexts>{errors["budget"]}</FormHelperTexts>
            </Grid>
            
            <EditButtons area='base' />

            {
              activeRow.id !== -1 ? (
                <>
                  <Grid item xs={12} style={{ display: 'flex', alignItems: 'center' }}>
                    <Typography variant='h6'>기수 연결</Typography>
                    <FormControlLabel
                      style={{ marginLeft: 10 }}
                      control={
                        <Checkbox
                          color="primary"
                          disabled={!canEdit('plan')}
                          checked={onlyAlive}
                          onChange={async (e) => {
                            set_onlyAlive(prev => !prev)
                          }}
                        />
                      }
                      label={`종강된 기수 제외`}
                    />
                    <FormControlLabel
                      style={{ marginLeft: 10 }}
                      control={
                        <Checkbox
                          color="primary"
                          disabled={!canEdit('plan')}
                          checked={autoChasu}
                          onChange={async (e) => {
                            set_autoChasu(prev => !prev)
                          }}
                        />
                      }
                      label={`기수 클릭 시 월단위 차수 자동 생성`}
                    />
                  </Grid>
                  <Grid item xs={12} >
                    <Grid container spacing={1} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 10 }}>
                      <Grid item xs={3}>
                        <Typography sx={{ fontWeight: 'bold' }}>년도/기수</Typography>
                      </Grid>
                      <Grid item xs={9}>
                        <Grid container spacing={1}>
                          <Grid item xs={3} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', }}>
                            <Typography style={{ marginRight: 10, fontWeight: 'bold' }}>차수 </Typography>
                            <Typography style={{ marginRight: 10, fontWeight: 'bold' }}> 마감여부</Typography>
                          </Grid>
                          <Grid item xs={4}>
                            <Typography sx={{ fontWeight: 'bold' }}>차수 시작일</Typography>
                          </Grid>
                          <Grid item xs={4}>
                            <Typography sx={{ fontWeight: 'bold' }}>차수 종료일</Typography>
                          </Grid>
                          <Grid item xs={1}>
                            <Typography sx={{ fontWeight: 'bold' }}>삭제</Typography>
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid item xs={12}>
                        <Divider />
                      </Grid>
                    </Grid>
                    <Grid container spacing={1} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      {
                        allSmsts.filter(s => onlyAlive ? s.phase < 2 : true).map((smst, idx) => {
                          return (
                            <Grid item xs={12} style={{ paddingBottom: 10, }}>
                              <Grid container spacing={1} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                <Grid item xs={3}>
                                  <FormControlLabel
                                    control={
                                      <Checkbox
                                        color="primary"
                                        disabled={!canEdit('plan')}
                                        // defaultChecked={factor.plans.find(p => p.smstId === smst.id)?.id}
                                        checked={smst.checked}
                                        onChange={async (e) => {
                                          if (e.target.checked) {
                                            if (autoChasu) {
                                              const plans = generatePlans(activeRow.id, smst.id, smst.lectureStime, smst.lectureEtime)
                                              smst.plans = [...plans]
                                            }
                                          }
                                          else {
                                            const closedPlans = smst.plans.filter(r => r.closeYn === 'Y')
                                            if (closedPlans.length > 0) {
                                              alert('마감된 차수가 있어 해제할 수 없습니다.')
                                              return
                                            }
                                            smst.plans = []

                                          }
                                          smst.checked = e.target.checked

                                          set_allSmsts([...allSmsts])
                                        }}
                                      />
                                    }
                                    label={`${smst.year}/${smst.gisu}`}
                                  />
                                  <IconButton disabled={!canEdit('plan')} onClick={() => {
                                    // <IconButton disabled={true} onClick={() => {
                                    const chasu = smst.plans.length === 0 ? 1 : smst.plans.length + 1
                                    const now = getNow()
                                    smst.plans.push({
                                      id: -1, voucherId: activeRow.id, smstId: smst.id, chasu: chasu, startTime: null, endTime: null, activeYn: 'N', closeYn: 'N',
                                      uptTime: now, regTime: now,
                                      key1: uuidv4(), key2: uuidv4()
                                    })
                                    smst.checked = true
                                    set_allSmsts([...allSmsts])
                                  }}
                                  >
                                    <AddOutlinedIcon />
                                  </IconButton>
                                </Grid>
                                <Grid item xs={9}>
                                  <Grid container spacing={1} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    {
                                      smst.plans.map((plan, idx) => {
                                        return (
                                          <Grid item xs={12} key={`plan-id:${plan.id}-${plan.chasu}`}>
                                            <Grid container spacing={1} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                              <Grid item xs={3} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                <Typography style={{ marginRight: 10 }}>{plan.chasu}</Typography>
                                                <Typography key={`plan-id;${plan.id}`} style={{ marginRight: 10 }}>{plan.closeYn}</Typography>

                                              </Grid>
                                              <Grid item xs={4}>
                                                <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={'ko'}>
                                                  <DatePicker
                                                    label={'차수 시작일'}
                                                    required
                                                    value={plan.startTime}
                                                    disabled={!canEdit('plan') || plan.closeYn === 'Y'}
                                                    defaultValue={null}
                                                    name={'startTime'}
                                                    inputFormat="YYYY-MM-DD"
                                                    onChange={(newValue) => {
                                                      if (!newValue || !newValue.isValid()) {
                                                        plan.startTime = null
                                                        set_allSmsts([...allSmsts])
                                                        set_dirtyFields({ ...dirtyFields, [plan.key1]: '날짜 형식이 맞지 않습니다.' })
                                                        return
                                                      }

                                                      const dtime = moment(new Date(newValue))
                                                      const d = dtime.format(dateFormat)
                                                      plan.startTime = d
                                                      set_allSmsts([...allSmsts])
                                                      validate2(smst.plans, plan, 'startTime', dtime)
                                                    }}
                                                    renderInput={(params) =>
                                                      <TextField name={'startTime'} fullWidth size="small" {...params}
                                                        inputRef={el => {
                                                          params.inputRef(el)
                                                          setInputRef(el, 'startTime')
                                                        }}
                                                      />
                                                    }
                                                  />
                                                </LocalizationProvider>
                                                <FormHelperTexts>{dirtyFields[plan.key1]}</FormHelperTexts>
                                              </Grid>
                                              <Grid item xs={4}>
                                                <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={'ko'}>
                                                  <DatePicker
                                                    label={'차수 종료일'}
                                                    required
                                                    value={plan.endTime}
                                                    disabled={!canEdit('plan') || plan.closeYn === 'Y'}
                                                    defaultValue={null}
                                                    name={'endTime'}
                                                    inputFormat="YYYY-MM-DD"
                                                    onChange={(newValue) => {
                                                      console.log('newValue=>', newValue)

                                                      if (!newValue || !newValue.isValid()) {
                                                        plan.endTime = null
                                                        set_allSmsts([...allSmsts])
                                                        set_dirtyFields({ ...dirtyFields, [plan.key2]: '날짜 형식이 맞지 않습니다.' })
                                                        return
                                                      }
                                                      // console.log('newValue', newValue)
                                                      const dtime = moment(new Date(newValue))
                                                      const d = dtime.format(dateFormat2)
                                                      plan['endTime'] = d
                                                      set_allSmsts([...allSmsts])
                                                      set_dirtyFields({ ...dirtyFields, [plan.key2]: '' })
                                                      
                                                      validate2(smst.plans, plan, 'endTime', dtime)
                                                    }}
                                                    renderInput={(params) =>
                                                      <TextField name={'endTime'} fullWidth size="small" {...params}
                                                        inputRef={el => {
                                                          params.inputRef(el)
                                                          setInputRef(el, 'endTime')
                                                        }}
                                                      />
                                                    }
                                                  />
                                                </LocalizationProvider>
                                                <FormHelperTexts>{dirtyFields[plan.key2]}</FormHelperTexts>
                                                {/* <FormHelperTexts>{plan.key2}</FormHelperTexts>       */}
                                              </Grid>
                                              <Grid item xs={1}>
                                                <IconButton disabled={!canEdit('plan') || plan.closeYn === 'Y'} onClick={() => {
                                                  // <IconButton disabled={true} onClick={() => {
                                                  if (idx !== smst.plans.length - 1) {
                                                    alert('이 후에 다른 차수가 있어 삭제할 수 없습니다. 뒷 차수부터 삭제해 주세요.')
                                                    return
                                                  }
                                                  delete dirtyFields[plan.key1];
                                                  delete dirtyFields[plan.key2];
                                                  set_dirtyFields({...dirtyFields})  
                                                  smst.plans.splice(idx, 1)
                                                  const planSize = smst.plans.length
                                                  console.log('plans len', smst.plans.length)
                                                  if (planSize === 0) {
                                                    console.log('plans len2', smst.plans.length)
                                                    smst.checked = false
                                                  }
                                                  else {
                                                    const prevPlan = smst.plans[smst.plans.length -1]
                                                    console.log('check prevPlan=>', prevPlan)
                                                    if(prevPlan?.endTime) {
                                                      const endTime = moment(prevPlan.endTime)
                                                      validate2(smst.plans, prevPlan, 'endTime', endTime)
                                                    }
                                                    
                                                  }

                                                  set_allSmsts([...allSmsts])

                                                }}>
                                                  <ClearOutlinedIcon />
                                                </IconButton>
                                              </Grid>
                                            </Grid>
                                          </Grid>
                                        )
                                      })
                                    }
                                  </Grid>
                                </Grid>
                              </Grid>
                              <Divider style={{marginTop:10}}/>
                            </Grid>
                          )
                        })
                      }
                    </Grid>

                    {/* <Grid container spacing={1} style={{ display: 'flex', alignItem: 'center', justifyContent: 'center' }}>
                      {
                        allSmsts.filter(s => onlyAlive ? s.phase < 2 : true).map((smst, idx) => {
                          const key = `chasu-smst-${smst.id}`
                          return (
                            <>
                              <Grid item xs={4}>
                                <FormControlLabel
                                  key={`smst-id-${smst.id}`}
                                  control={
                                    <Checkbox
                                      color="primary"
                                      disabled={!canEdit('plan')}
                                      defaultChecked={factor.plans.find(p => p.smstId === smst.id)?.id}

                                      onChange={async (e) => {
                                        smst.checked = e.target.checked
                                        const foundIdx = factor.plans.findIndex(r => r.smstId === smst.id)
                                        if (e.target.checked) {
                                          if (foundIdx < 0) {
                                            const now = moment().format(dateFormat)
                                            const plan = {
                                              smstId: smst.id, voucherId: factor.id, chasu: -1,
                                              uptTime: now,
                                              regTime: now,
                                              smst: { ...smst }
                                            }
                                            factor.plans.push(plan)
                                          }
                                          handleChange({ name: `${key}`, value: inputRefs.current[key].value })
                                        }
                                        else {
                                          if (foundIdx >= 0) {
                                            factor.plans.splice(foundIdx, 1)
                                          }
                                          inputRefs.current[key].value = ''
                                          handleChange({ name: `${key}`, value: () => { return '' } })
                                          updateState()
                                        }
                                      }}
                                    />
                                  }
                                  label={`${smst.year}/${smst.gisu}`}
                                />
                              </Grid>
                              <Grid item xs={2}>
                                <TextField
                                  placeholder='차수'
                                  disabled={!canEdit('plan')}
                                  inputRef={el => inputRefs.current[key] = el}
                                  defaultValue={factor.plans.find(p => p.smstId === smst.id)?.chasu}
                                  name={key}
                                  onChange={(e) => {
                                    const foundIdx = factor.plans.findIndex(r => r.smstId === smst.id)
                                    if (foundIdx >= 0) {
                                      console.log('foundIdx=>', foundIdx)
                                      factor.plans[foundIdx].chasu = +e.target.value
                                    }
                                    console.log('factor1->', factor)
                                    handleChange(e)
                                    console.log('factor2->', factor)
                                    updateState()
                                    console.log('factor4->', factor)
                                  }}
                                />
                                <FormHelperTexts>{errors[key]}</FormHelperTexts>
                              </Grid>
                              <Grid item xs={2}>
                                <TextField fullWidth />
                              </Grid>
                              <Grid item xs={2}>
                                <TextField fullWidth />
                              </Grid>
                              <Grid item xs={2}>
                                <IconButton>
                                  <ClearOutlinedIcon />
                                </IconButton>
                              </Grid>
                            </>
                          )
                        })
                      }
                    </Grid> */}

                  </Grid>
                </>
              ) : null
            }

            <EditButtons area='plan' />
          </Grid>

        </DialogContent>
        <DialogActions >
          <Grid container spacing={1}>
            <Grid item xs={12} style={{ display: 'flex', justifyContent: 'center' }}>
              <Button style={{ marginRight: 10 }}
                onClick={() => {
                  if (activeRow.id > 0) {
                    for (const [name, value] of Object.entries(editArea)) {
                      if (value) {
                        alert('현재 편집 중인 데이터가 있습니다. 취소 또는 저장을 선택 후 창을 닫아 주세요.')
                        return
                      }
                    }
                    handleClose()
                  }
                  else {
                    handleClose()
                  }
                }}
              >
                닫기
              </Button>
              {
                activeRow.id === -1 ? (
                  <ConfirmDialog
                    btn={
                      <Button variant='contained' disabled={false}
                        onMouseOver={() => {
                          document.activeElement?.blur();
                        }}
                      >
                        저장
                      </Button>
                    }
                    title={'저장'}
                    content=''
                    bc={'primary'}
                    preHandle={async () => {
                      return true
                    }}
                    perform={async () => {
                      const error = await handleChange()
                      console.log('error=>', error)
                      if (Object.keys(error).length > 0) {
                        alert('화면의 에러를 확인해 주세요.')
                        return
                      }

                      onSubmit()
                    }}
                  />
                ) : null
              }

            </Grid>
          </Grid>

        </DialogActions>
      </Dialog>

    </Box>

  )
}

export default ManagerVoucherPartMod
